import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default {
  __name: 'RecordButton',
  props: {
  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'primary', 'quiet', 'danger'].includes(value)
  },
  size: { type: String, default: 'md', validator: value => ['sm', 'md'].includes(value) },
  type: { type: String, default: 'button' },
  to: { type: [String, Object], default: null }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.to ? 'router-link' : 'button'), {
    to: __props.to,
    type: __props.to ? undefined : __props.type,
    class: _normalizeClass(["record-btn", [`record-btn--${__props.variant}`, __props.size === 'sm' && 'record-btn--sm']])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["to", "type", "class"]))
}
}

}